import { AllLocationResponseModel, RackPositionIdRequest } from '@gtpl/shared-models/masters';
import { CommonResponse, ForkLiftJobIdRequest, ForkLiftJobUpdateRequest, GetAllForkLiftJobsResponseModel, GetForkLiftJobResponseModel, JobIdRequest, PlantIdRequest, updateJobQty } from '@gtpl/shared-models/warehouse-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { handleRetry } from '@nestjs/typeorm';
import { DriverJobDto } from '../stock/dto/driver-job.dto';
import { ForkLiftJobUpdateDto } from '../stock/dto/fork-lift-job-update.dto';
import { ForkliftJobDto } from '../stock/dto/fork-lift-jobs.dto';
import { OutBoundRequest } from '../stock/dto/out-bound.request';
import { CancelDriverJobRequest } from './dto/cancel-driver-job.request';
import { DeviceRequest } from './dto/device.request';
import { ForkLiftJobDto } from './dto/fork-lift-job.dto';
import { ForkLiftJobRequest } from './dto/fork-lift-job.request';
import { ForkLiftUpdateRequest } from './dto/fork-lift-update.request';
import { LocationSuggestRequest } from './dto/location-suggest.request';
import { ForkLiftJobsService } from './fork-lift-jobs.service';
@ApiTags('fork-lift-jobs')
@Controller('fork-lift-jobs')
export class ForkLiftJobsController {
    constructor(
        private forkLiftJobsService: ForkLiftJobsService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

      ){}
      @Post('/createForkLiftJob')
      async createForkLiftJob(@Body() forkLiftJobDto:ForkLiftJobDto,isUpdate:boolean=false,@Req() request:Request): Promise<GetForkLiftJobResponseModel> {
          console.log(forkLiftJobDto);
          try {
              return await this.forkLiftJobsService.createForkLiftJob(forkLiftJobDto, false,request);
          } catch (error) {
              return this.applicationExceptionhandler.returnException(GetForkLiftJobResponseModel, error)
          }
      }
    @Post('/updateForkLiftJobStatus')
        async updateForkLiftJobStatus(@Body() forkLiftJobRequest: ForkLiftJobRequest): Promise<GetForkLiftJobResponseModel> {
        try {
        return await this.forkLiftJobsService.updateForkLiftJobStatus(forkLiftJobRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetForkLiftJobResponseModel, error)
        }
    }

    @Post('/dispatchStock')
        async dispatchStock(@Body() forkLiftJobRequest: ForkLiftJobRequest): Promise<GetForkLiftJobResponseModel> {
        try {
        return await this.forkLiftJobsService.dispatchStock(forkLiftJobRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetForkLiftJobResponseModel, error)
        }
    }
    @Post('/getDriverJobs')
        async getDriverJobs(@Body() plantIdRequest:PlantIdRequest): Promise<GetAllForkLiftJobsResponseModel> {
        try {
        return await this.forkLiftJobsService.getDriverJobs(plantIdRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetAllForkLiftJobsResponseModel, error)
        }
    }
    @Post('/cancelDriverJob')
    async cancelDriverJob(@Body() outBoundRequest:CancelDriverJobRequest):Promise<CommonResponse>
    {
        try {
            return await this.forkLiftJobsService.cancelDriverJob(outBoundRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(GetAllForkLiftJobsResponseModel, error)
        }
    }
    @Post('/updateDriverJob')
    async updateDriverJob(@Body() forkLiftUpdateRequest:ForkLiftUpdateRequest):Promise<CommonResponse>
    {
        try {
            return await this.forkLiftJobsService.updateDriverJob(forkLiftUpdateRequest);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }
    
    // @Post('/suggestLocation')
    //     async suggestLocation(@Body() locationSuggestRequest:LocationSuggestRequest):Promise<AllLocationResponseModel>
    //     {
    //         try {
    //         return await this.forkLiftJobsService.suggestLocation(locationSuggestRequest);
    //         } catch (error) {
    //           return this.applicationExceptionhandler.returnException(AllLocationResponseModel, error)
    //     }
    // }
    

    /**
     * This service is used to update postions of pallet by fork lift machine
     * @param forkLiftJobUpdateDto 
     * @returns 
     */
    @Post('/updateDriverJobByForkLift')
    async updateDriverJobByForkLift(@Body() forkLiftJobUpdateDto:ForkLiftJobUpdateDto):Promise<CommonResponse>
    {
        try {
            return await this.forkLiftJobsService.updateDriverJobByForkLift(forkLiftJobUpdateDto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }


    @Post('/createOrUpdateDriverJob')
    async createOrUpdateDriverJob(@Body() driverJobDto:DriverJobDto):Promise<CommonResponse>
    {
        try {
            return await this.forkLiftJobsService.createOrUpdateDriverJob(driverJobDto);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(CommonResponse, error)
        }
    }
    @Post('/getForkliftJobs')
    async getForkliftJobs():Promise<CommonResponse>
    {
        try{
            return await this.forkLiftJobsService.getForkliftJobs();
        }catch(error)
        {
            return error;
        }
    }
    @Post('/getForkliftJobCodes')
    async getForkliftJobCodes(@Body() forkliftJobDto:ForkliftJobDto):Promise<CommonResponse>
    {
        try{
            return await this.forkLiftJobsService.getForkliftJobCodes(forkliftJobDto);
        }catch(error)
        {
            return error;
        }
    }

    @Post('/getForkliftJobCodesForGrid')
    async getForkliftJobCodesForGrid(@Body() forkliftJobDto:ForkliftJobDto):Promise<CommonResponse>
    {
        try{
           return await this.forkLiftJobsService.getForkliftJobCodesForGrid(forkliftJobDto);
        }catch(error)
        {
            return error;
        }
    }
    @Post('/getSosAgainstJob')
    async getSosAgainstJob(@Body() req: JobIdRequest): Promise<CommonResponse> 
    {
        try{
            return await this.forkLiftJobsService.getSosAgainstJob(req);
        }catch(error)
        {
            return error;
        }
    }

    @Post('/updateForkLiftJobQty')
    async updateForkLiftJobQty(@Body() req: updateJobQty): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.updateForkLiftJobQty(req);
        }catch(error)
        {
            return error;
        }
    }
    @Post('/getAllStockTranserDcData')
    async getAllStockTranserDcData(@Body() req: PlantIdRequest): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.getAllStockTranserDcData(req);
        }catch(error)
        {
            return error;
        }
    }
    @Post('/getAllStockTranserMrnData')
    async getAllStockTranserMrnData(@Body() req: PlantIdRequest): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.getAllStockTranserMrnData(req);
        }catch(error)
        {
            return error;
        }
    }
    @Post('/getStockTranserItemsData')
    async getStockTranserItemsData(@Body() req: JobIdRequest): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.getStockTranserItemsData(req);
        }catch(error)
        {
            return error;
        }
    }
    @Post('/OperateDevice')
    async OperateDevice(@Body() req: DeviceRequest): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.OperateDevice(req);
        }catch(error)
        {
            return error;
        }
    }

    @Post('/updatePlaceListJob')
    async updatePlaceListJob(@Body() forkLiftJobStatusRequest: ForkLiftJobUpdateRequest): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.updatePlaceListJob(forkLiftJobStatusRequest);
        }catch(error)
        {
            return error;
        }
    }

    @Post('/getJobDetailsByLocation')
    async getJobDetailsByLocation(@Body() req: RackPositionIdRequest): Promise<CommonResponse> {
        try{
            return await this.forkLiftJobsService.getJobDetailsByLocation(req);
        }catch(error)
        {
            return error;
        }
    }


    // @Post('/getAllForkLiftItemsByJobId')
    // async getAllForkLiftItemsByJobId(@Body() req: ForkLiftJobIdRequest): Promise<CommonResponse> {
    //     try{
    //         return await this.forkLiftJobsService.getAllForkLiftItemsByJobId(req);
    //     }catch(error)
    //     {
    //         return error;
    //     }
    // }
}
